import { ErrorCode } from '@afterpaytouch/portal-api'

export type OnboardingErrorCode = ErrorCode.UnsuitabilityNotFound | ErrorCode.UnsuitabilityExpired | ErrorCode.ContractAcceptanceRequired

export const AU_REG_ERROR_CODES: ErrorCode[] = [ErrorCode.UnsuitabilityNotFound, ErrorCode.UnsuitabilityExpired, ErrorCode.ContractAcceptanceRequired]

export const AFFORDABILITY_ERROR_CODES: ErrorCode[] = [ErrorCode.AffordabilityNotFound, ErrorCode.AffordabilityExpired]
